"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeThroughoutSummary = exports.ChangeThroughoutPlaces = void 0;
exports.cardContextWithChangeThroughoutPlaces = cardContextWithChangeThroughoutPlaces;
exports.cardSummaryOfChangeThroughout = cardSummaryOfChangeThroughout;
exports.changeThroughoutConflictsOf = changeThroughoutConflictsOf;
var _react = _interopRequireWildcard(require("react"));
var _lucideReact = require("lucide-react");
var _collisionWording = require("@common/components/remedy/collision-wording");
var _revisionStyle = require("@common/components/remedy/revision-style");
var _AnalyticsContext = require("../../../context/AnalyticsContext");
var _DocumentPageContext = require("../../../context/DocumentPageContext");
var _changeThroughoutSelections = require("./change-throughout-selections");
var _ChangeThroughoutPlaceLiveWords = require("./ChangeThroughoutPlaceLiveWords");
var _documentAlreadyReads = require("./document-already-reads");
var _RevertedInDocumentIndicator = require("./RevertedInDocumentIndicator");
var _locateProposalCard = require("./locate-proposal-card");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var HEADING_PATH_SEPARATOR = " › ";
var ELLIPSIS = "…";
var placeTextClass = "text-[11px] leading-[16px] text-[#686766]";
var deletedTextClass = "text-[#A81E36] line-through decoration-[#A81E36]";
var insertedTextClass = "text-[#1F5FA8]";
var checkboxClass = "w-3.5 h-3.5 mt-[1px] cursor-pointer accent-primary flex-shrink-0 disabled:cursor-not-allowed disabled:opacity-50";
var NOT_CHANGED_REASONS = new Map([["anchorOverlap", "it runs into the place before it"], ["textGluesWords", "the new words would run into the word beside them"], ["textGluesSentences", "the new words would run into the sentence beside them"], ["textDoublesSpace", "the new words would leave a double space"], ["textDoublesPunctuation", "the new words would double a punctuation mark"], ["occurrenceMissing", "the paragraph no longer reads it there"]]);
var ANY_OTHER_NOT_CHANGED_REASON = "it can't be changed there";
function groupOf(match) {
  var outermostCell = match.table_cell_path[0];
  if (outermostCell !== undefined) return {
    key: "table-".concat(outermostCell.tableNumber),
    label: "Table ".concat(outermostCell.tableNumber)
  };
  if (match.heading_path !== null && match.heading_path.length > 0) {
    var label = match.heading_path.join(HEADING_PATH_SEPARATOR);
    return {
      key: "heading-".concat(label),
      label: label
    };
  }
  return {
    key: "before-first-heading",
    label: "Before the first heading"
  };
}
function groupsOf(places) {
  var groupByKey = new Map();
  var _iterator = _createForOfIteratorHelper(places),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var place = _step.value;
      var group = groupOf(place);
      var existing = groupByKey.get(group.key);
      if (existing === undefined) groupByKey.set(group.key, _objectSpread(_objectSpread({}, group), {}, {
        places: [place]
      }));else existing.places.push(place);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return _toConsumableArray(groupByKey.values());
}
function cellNameOf(cell) {
  if (cell.columnHeading === null) return "row ".concat(cell.rowNumber, ", cell ").concat(cell.cellNumber);
  return "row ".concat(cell.rowNumber, ", ").concat(cell.columnHeading);
}
function shownTextBeforeOf(place) {
  if (place.text_before.length === 0) return "";
  return "".concat(ELLIPSIS).concat(place.text_before);
}
function shownTextAfterOf(place) {
  if (place.text_after.length === 0) return "";
  return "".concat(place.text_after).concat(ELLIPSIS);
}
function notChangedReasonOf(reaskReason) {
  var notChangedReason = NOT_CHANGED_REASONS.get(reaskReason);
  if (notChangedReason === undefined) return ANY_OTHER_NOT_CHANGED_REASON;
  return notChangedReason;
}
function countsLineOf(card, checkedPlaces) {
  var _card$change_througho = card.change_throughout,
    changed_matches = _card$change_througho.changed_matches,
    matches_left_out_by_the_agent = _card$change_througho.matches_left_out_by_the_agent,
    matches_the_web_handed_back = _card$change_througho.matches_the_web_handed_back;
  var checkablePlaces = [].concat(_toConsumableArray(changed_matches), _toConsumableArray(matches_left_out_by_the_agent));
  var everyPlaceFound = [].concat(_toConsumableArray(checkablePlaces), _toConsumableArray(matches_the_web_handed_back.map(function (handedBack) {
    return handedBack.match;
  })));
  var selectedCount = checkablePlaces.filter(function (place) {
    return checkedPlaces.has(place.match_id);
  }).length;
  var inTablesCount = everyPlaceFound.filter(function (place) {
    return place.table_cell_path.length > 0;
  }).length;
  var leftOutCount = matches_left_out_by_the_agent.length;
  var countParts = ["".concat(selectedCount, " of ").concat(everyPlaceFound.length, " places selected")];
  if (inTablesCount > 0) countParts.push("".concat(inTablesCount, " in tables"));
  if (leftOutCount > 0) countParts.push("".concat(leftOutCount, " left out by the agent"));
  return countParts.join(" · ");
}
var PlaceInItsWords = function PlaceInItsWords(_ref) {
  var place = _ref.place,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [shownTextBeforeOf(place), children, shownTextAfterOf(place)]
  });
};
var PlaceWords = function PlaceWords(_ref2) {
  var place = _ref2.place,
    textWanted = _ref2.textWanted;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: deletedTextClass,
      children: place.text
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: insertedTextClass,
      style: _revisionStyle.INSERTION_UNDERLINE,
      children: textWanted
    })]
  });
};
var PlaceLocateButton = function PlaceLocateButton(_ref3) {
  var place = _ref3.place;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      void (0, _locateProposalCard.locateChangeThroughoutPlace)(place);
    },
    className: "flex-shrink-0 ml-auto pl-2 bg-transparent border-none p-0 text-[11px] text-primary cursor-pointer hover:underline",
    "data-sentry-component": "PlaceLocateButton",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: "Locate"
  });
};
var APPLIED_PLACE = {
  result: "applied"
};
var REVERTED_PLACE = {
  result: "reverted"
};
function placeOutcomeWrittenFor(place, selection) {
  var recordedOutcome = selection.placeOutcomes.get(place.match_id);
  if (recordedOutcome !== undefined) return recordedOutcome;
  if (selection.cardState === "applied" && selection.checkedPlaces.has(place.match_id)) return APPLIED_PLACE;
  return null;
}
function placeOutcomeShownFor(place, selection, page) {
  var writtenOutcome = placeOutcomeWrittenFor(place, selection);
  if ((writtenOutcome === null || writtenOutcome === void 0 ? void 0 : writtenOutcome.result) !== "applied" || page === null) return writtenOutcome;
  if ((0, _documentAlreadyReads.documentLandingOfCard)((0, _ChangeThroughoutPlaceLiveWords.placeAloneProposalOf)(selection.card, place), page) === "not_applied") return REVERTED_PLACE;
  return writtenOutcome;
}
function revertedPlacesCountOf(selection, page) {
  var _selection$card$chang = selection.card.change_throughout,
    changed_matches = _selection$card$chang.changed_matches,
    matches_left_out_by_the_agent = _selection$card$chang.matches_left_out_by_the_agent;
  var placeResults = [].concat(_toConsumableArray(changed_matches), _toConsumableArray(matches_left_out_by_the_agent)).map(function (place) {
    var _placeOutcomeShownFor;
    return (_placeOutcomeShownFor = placeOutcomeShownFor(place, selection, page)) === null || _placeOutcomeShownFor === void 0 ? void 0 : _placeOutcomeShownFor.result;
  });
  var revertedPlaceCount = placeResults.filter(function (placeResult) {
    return placeResult === "reverted";
  }).length;
  if (revertedPlaceCount === 0) return null;
  return {
    revertedPlaceCount: revertedPlaceCount,
    appliedPlaceCount: revertedPlaceCount + placeResults.filter(function (placeResult) {
      return placeResult === "applied";
    }).length
  };
}
var PlaceOutcomeLabel = function PlaceOutcomeLabel(_ref4) {
  var placeOutcome = _ref4.placeOutcome;
  if (placeOutcome === null) return null;
  switch (placeOutcome.result) {
    case "applied":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[#10B981] font-medium",
        children: " \xB7 Applied"
      });
    case "reverted":
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "text-[#92400E] font-medium",
        children: [" \xB7 ", _RevertedInDocumentIndicator.REVERTED_IN_DOCUMENT_LABEL]
      });
    case "notApplied":
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "text-[#A81E36] font-medium",
        children: [" \xB7 Not applied: ", placeOutcome.reason]
      });
    case "notChosen":
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "text-[#92400E] font-medium",
        children: [" \xB7 Not chosen: ", placeOutcome.reason]
      });
  }
};
var PlaceCell = function PlaceCell(_ref5) {
  var place = _ref5.place;
  var innermostCell = place.table_cell_path[place.table_cell_path.length - 1];
  if (innermostCell === undefined) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "text-[#8a8886]",
    "data-sentry-component": "PlaceCell",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: [" (", cellNameOf(innermostCell), ")"]
  });
};
var PlaceRow = function PlaceRow(_ref6) {
  var place = _ref6.place,
    selection = _ref6.selection;
  var isChecked = selection.checkedPlaces.has(place.match_id);
  var page = (0, _DocumentPageContext.useDocumentPageIfAny)();
  var placeOutcome = placeOutcomeShownFor(place, selection, page);
  var wordsWhenProposed = /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceInItsWords, {
    place: place,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceWords, {
      place: place,
      textWanted: selection.textWanted
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "flex items-start gap-1.5 ".concat(placeTextClass),
    "data-match-id": place.match_id,
    "data-sentry-component": "PlaceRow",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "checkbox",
      checked: isChecked,
      disabled: selection.locked,
      onChange: function onChange(event) {
        return selection.onCheckedChange([place.match_id], event.target.checked);
      },
      className: checkboxClass
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "min-w-0 flex-1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChangeThroughoutPlaceLiveWords.ChangeThroughoutPlaceLiveWords, {
        card: selection.card,
        place: place,
        placeIsApplied: (placeOutcome === null || placeOutcome === void 0 ? void 0 : placeOutcome.result) === "applied",
        wordsWhenProposed: wordsWhenProposed,
        "data-sentry-element": "ChangeThroughoutPlaceLiveWords",
        "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceCell, {
        place: place,
        "data-sentry-element": "PlaceCell",
        "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceOutcomeLabel, {
        placeOutcome: placeOutcome,
        "data-sentry-element": "PlaceOutcomeLabel",
        "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceLocateButton, {
      place: place,
      "data-sentry-element": "PlaceLocateButton",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    })]
  });
};
var GroupCheckbox = function GroupCheckbox(_ref7) {
  var group = _ref7.group,
    selection = _ref7.selection;
  var checkboxRef = (0, _react.useRef)(null);
  var checkedCount = group.places.filter(function (place) {
    return selection.checkedPlaces.has(place.match_id);
  }).length;
  var everyPlaceChecked = checkedCount === group.places.length;
  var somePlacesChecked = checkedCount > 0 && !everyPlaceChecked;
  (0, _react.useEffect)(function () {
    if (checkboxRef.current !== null) checkboxRef.current.indeterminate = somePlacesChecked;
  }, [somePlacesChecked]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "flex items-center gap-1.5 text-[11px] font-medium text-[#4a5568]",
    "data-sentry-component": "GroupCheckbox",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ref: checkboxRef,
      type: "checkbox",
      checked: everyPlaceChecked,
      disabled: selection.locked,
      onChange: function onChange(event) {
        return selection.onCheckedChange(group.places.map(function (place) {
          return place.match_id;
        }), event.target.checked);
      },
      className: checkboxClass
    }), group.label]
  });
};
var PlaceGroups = function PlaceGroups(_ref8) {
  var places = _ref8.places,
    selection = _ref8.selection;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex flex-col gap-1",
    "data-sentry-component": "PlaceGroups",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: groupsOf(places).map(function (group) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-0.5",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(GroupCheckbox, {
          group: group,
          selection: selection
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex flex-col gap-0.5 pl-4",
          children: group.places.map(function (place) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceRow, {
              place: place,
              selection: selection
            }, place.match_id);
          })
        })]
      }, group.key);
    })
  });
};
var LeftOutPlaces = function LeftOutPlaces(_ref9) {
  var places = _ref9.places,
    selection = _ref9.selection;
  if (places.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-0.5",
    "data-testid": "change-throughout-left-out",
    "data-sentry-component": "LeftOutPlaces",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-[11px] font-medium text-[#4a5568]",
      children: "Left out by the agent"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex flex-col gap-0.5 pl-4",
      children: places.map(function (place) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceRow, {
          place: place,
          selection: selection
        }, place.match_id);
      })
    })]
  });
};
var PlacesNotChanged = function PlacesNotChanged(_ref0) {
  var places = _ref0.places;
  if (places.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-0.5",
    "data-testid": "change-throughout-not-changed",
    "data-sentry-component": "PlacesNotChanged",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-[11px] font-medium text-[#4a5568]",
      children: "Can't be changed"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex flex-col gap-0.5 pl-4",
      children: places.map(function (_ref1) {
        var match = _ref1.match,
          reaskReason = _ref1.reaskReason;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: placeTextClass,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceInItsWords, {
            place: match,
            children: match.text
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "text-[#8a8886]",
            children: [" \u2014 ", notChangedReasonOf(reaskReason)]
          })]
        }, match.match_id);
      })
    })]
  });
};
var RevertedPlacesCountLabel = function RevertedPlacesCountLabel(_ref10) {
  var revertedPlaces = _ref10.revertedPlaces;
  if (revertedPlaces === null) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "text-[#92400E] font-medium",
    "data-sentry-component": "RevertedPlacesCountLabel",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: " \xB7 ".concat(revertedPlaces.revertedPlaceCount, " of ").concat(revertedPlaces.appliedPlaceCount, " places reverted")
  });
};
var ChangeThroughoutSummaryLine = function ChangeThroughoutSummaryLine(_ref11) {
  var selection = _ref11.selection;
  var page = (0, _DocumentPageContext.useDocumentPageIfAny)();
  var card = selection.card,
    checkedPlaces = selection.checkedPlaces;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: placeTextClass,
    "data-sentry-component": "ChangeThroughoutSummaryLine",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: ["Changes ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[#4a5568] bg-[#FFF7E0] rounded px-0.5",
      children: "\"".concat(card.change_throughout.text_now, "\"")
    }), " to", " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[#4a5568] bg-[#FFF7E0] rounded px-0.5",
      children: "\"".concat(card.change_throughout.text_wanted, "\"")
    }), ": ", countsLineOf(card, checkedPlaces), /*#__PURE__*/(0, _jsxRuntime.jsx)(RevertedPlacesCountLabel, {
      revertedPlaces: revertedPlacesCountOf(selection, page),
      "data-sentry-element": "RevertedPlacesCountLabel",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    })]
  });
};
var ChangeThroughoutSummary = exports.ChangeThroughoutSummary = function ChangeThroughoutSummary(_ref12) {
  var card = _ref12.card,
    actionId = _ref12.actionId,
    cardState = _ref12.cardState;
  (0, _changeThroughoutSelections.useChangeThroughoutSelectionsVersion)();
  var selection = {
    card: card,
    checkedPlaces: _changeThroughoutSelections.changeThroughoutSelections.checkedPlacesOf(actionId, card),
    placeOutcomes: _changeThroughoutSelections.changeThroughoutSelections.placeOutcomesOf(actionId, card),
    cardState: cardState
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "change-throughout-summary",
    "data-sentry-component": "ChangeThroughoutSummary",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ChangeThroughoutSummaryLine, {
      selection: selection,
      "data-sentry-element": "ChangeThroughoutSummaryLine",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    })
  });
};
var ConflictingCardButton = function ConflictingCardButton(_ref13) {
  var link = _ref13.link;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    type: "button",
    onClick: function onClick(event) {
      event.stopPropagation();
      link.onShow();
    },
    className: "bg-transparent border-none p-0 font-medium text-primary cursor-pointer hover:underline",
    "data-sentry-component": "ConflictingCardButton",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: ["#", link.cardNumber]
  });
};
function separatorBefore(position, count) {
  if (position === 0) return "";
  if (position === count - 1) return " & ";
  return ", ";
}
var ConflictLine = function ConflictLine(_ref14) {
  var conflict = _ref14.conflict;
  var cardCountInTheConflict = conflict.otherCards.length + 1;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "status",
    className: "flex items-start gap-1 text-[11px] leading-[16px] text-[#92400E]",
    "data-sentry-component": "ConflictLine",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.AlertTriangle, {
      size: 12,
      "aria-hidden": "true",
      className: "flex-shrink-0 mt-[2px]",
      "data-sentry-element": "AlertTriangle",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      children: ["#", conflict.cardNumber, conflict.otherCards.map(function (link, position) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
          children: [separatorBefore(position + 1, cardCountInTheConflict), /*#__PURE__*/(0, _jsxRuntime.jsx)(ConflictingCardButton, {
            link: link
          })]
        }, link.cardNumber);
      }), " ", (0, _collisionWording.groupPredicateOf)(conflict.proximity)]
    })]
  });
};
var ConflictLines = function ConflictLines(_ref15) {
  var conflicts = _ref15.conflicts;
  if (conflicts.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex flex-col gap-0.5",
    "data-testid": "change-throughout-conflicts",
    "data-sentry-component": "ConflictLines",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: conflicts.map(function (conflict) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ConflictLine, {
        conflict: conflict
      }, conflict.key);
    })
  });
};
var SummaryLineAboveThePlaces = function SummaryLineAboveThePlaces(_ref16) {
  var placement = _ref16.placement,
    selection = _ref16.selection;
  if (placement === "inTheCardsFoldRow") return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ChangeThroughoutSummaryLine, {
    selection: selection,
    "data-sentry-element": "ChangeThroughoutSummaryLine",
    "data-sentry-component": "SummaryLineAboveThePlaces",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
  });
};
var ChangeThroughoutPlaces = exports.ChangeThroughoutPlaces = function ChangeThroughoutPlaces(_ref17) {
  var card = _ref17.card,
    actionId = _ref17.actionId,
    cardState = _ref17.cardState,
    checkedPlacesHandedBack = _ref17.checkedPlacesHandedBack,
    summaryLine = _ref17.summaryLine,
    conflicts = _ref17.conflicts;
  (0, _changeThroughoutSelections.useChangeThroughoutSelectionsVersion)();
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics;
  var checkedPlaces = _changeThroughoutSelections.changeThroughoutSelections.checkedPlacesOf(actionId, card);
  var selection = {
    card: card,
    checkedPlaces: checkedPlaces,
    placeOutcomes: _changeThroughoutSelections.changeThroughoutSelections.placeOutcomesOf(actionId, card),
    cardState: cardState,
    locked: cardState !== "pending",
    textWanted: card.change_throughout.text_wanted,
    onCheckedChange: function onCheckedChange(matchIds, isChecked) {
      var nextCheckedPlaces = new Set(checkedPlaces);
      var _iterator2 = _createForOfIteratorHelper(matchIds),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var matchId = _step2.value;
          if (isChecked) nextCheckedPlaces.add(matchId);else nextCheckedPlaces.delete(matchId);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      _changeThroughoutSelections.changeThroughoutSelections.setCheckedPlaces(actionId, card, nextCheckedPlaces);
      analytics === null || analytics === void 0 || analytics.track("change_throughout_places_selected", {
        actionId: actionId,
        matchIds: matchIds,
        isChecked: isChecked,
        checkedPlaceCount: nextCheckedPlaces.size
      });
    }
  };
  var placesNotChanged = [].concat(_toConsumableArray(card.change_throughout.matches_the_web_handed_back.map(function (handedBack) {
    return {
      match: handedBack.match,
      reaskReason: handedBack.reask_reason
    };
  })), _toConsumableArray(checkedPlacesHandedBack.map(function (handedBack) {
    return {
      match: handedBack.match,
      reaskReason: handedBack.reaskReason
    };
  })));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1.5",
    "data-testid": "change-throughout-places",
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    "data-sentry-component": "ChangeThroughoutPlaces",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SummaryLineAboveThePlaces, {
      placement: summaryLine,
      selection: selection,
      "data-sentry-element": "SummaryLineAboveThePlaces",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ConflictLines, {
      conflicts: conflicts,
      "data-sentry-element": "ConflictLines",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceGroups, {
      places: card.change_throughout.changed_matches,
      selection: selection,
      "data-sentry-element": "PlaceGroups",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LeftOutPlaces, {
      places: card.change_throughout.matches_left_out_by_the_agent,
      selection: selection,
      "data-sentry-element": "LeftOutPlaces",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PlacesNotChanged, {
      places: placesNotChanged,
      "data-sentry-element": "PlacesNotChanged",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    })]
  });
};
function byCardNumber(left, right) {
  return left.cardNumber - right.cardNumber;
}
function changeThroughoutConflictsOf(cardNumber, collisions) {
  if (cardNumber === undefined) return [];
  var otherCardsByProximity = new Map();
  var _iterator3 = _createForOfIteratorHelper(collisions),
    _step3;
  try {
    var _loop = function _loop() {
      var _otherCardsByProximit;
      var collision = _step3.value;
      var otherCards = (_otherCardsByProximit = otherCardsByProximity.get(collision.proximity)) !== null && _otherCardsByProximit !== void 0 ? _otherCardsByProximit : [];
      if (otherCards.some(function (otherCard) {
        return otherCard.cardNumber === collision.number;
      })) return 1; // continue
      otherCardsByProximity.set(collision.proximity, [].concat(_toConsumableArray(otherCards), [{
        cardNumber: collision.number,
        onShow: collision.onShow
      }]));
    };
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return _toConsumableArray(otherCardsByProximity).map(function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
      proximity = _ref19[0],
      otherCards = _ref19[1];
    return {
      key: proximity,
      proximity: proximity,
      cardNumber: cardNumber,
      otherCards: _toConsumableArray(otherCards).sort(byCardNumber)
    };
  });
}
function cardContextWithChangeThroughoutPlaces(cardContext, changeThroughoutSelection, placesShown) {
  if (changeThroughoutSelection === null) return cardContext;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1",
    "data-sentry-component": "cardContextWithChangeThroughoutPlaces",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ChangeThroughoutPlaces, {
      card: changeThroughoutSelection.card,
      actionId: placesShown.actionId,
      cardState: placesShown.cardState,
      checkedPlacesHandedBack: changeThroughoutSelection.checkedPlacesHandedBack,
      summaryLine: placesShown.summaryLine,
      conflicts: placesShown.conflicts,
      "data-sentry-element": "ChangeThroughoutPlaces",
      "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
    }), cardContext]
  });
}
function cardSummaryOfChangeThroughout(changeThroughoutSelection, actionId, cardState) {
  if (changeThroughoutSelection === null) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ChangeThroughoutSummary, {
    card: changeThroughoutSelection.card,
    actionId: actionId,
    cardState: cardState,
    "data-sentry-element": "ChangeThroughoutSummary",
    "data-sentry-component": "cardSummaryOfChangeThroughout",
    "data-sentry-source-file": "ChangeThroughoutPlaces.tsx"
  });
}